import axios from "axios";
import moment from "moment-timezone";
import { getItem } from "../utils/storage";
import { getApiDomain } from "../agent/config";
import getV2AxiosInstance from "../utils/v2Axios.js";
import getGrapQLAxiosInstance from "../utils/graphQLAxios.js";
import { logData } from "../utils/utils";
import { ID_TOKEN } from "../utils/authutils";

var allOngoingCallsData = [];

export const modifyAgentInfo = (data) => {
  return {
    type: "MODIFY_AGENT_INFO",
    payload: data,
  };
};

// export function modifyAgentInfo(data){
//   return dispatch => {
//      return dispatch({
//          type: 'MODIFY_AGENT_INFO',
//          payload: data
//      });
//   };
// }

export function setAgentConfig(data) {

  return {
    type: "SET_AGENT_CONFIG",
    payload: data,
  };
}

export function setAgentInfo(data) {
  data.avatar = data.avatar
    ? `${data.avatar}?time=${moment().unix()}`
    : data.avatar;
  return {
    type: "SET_AGENT_INFO",
    payload: data,
  };
}

export function setAgents(data) {
  return {
    type: "SET_AGENTS",
    payload: data,
  };
}
export function setAgentPermission(data) {
  return {
    type: "SET_AGENTPERMISSIONS",
    payload: data,
  };
}

export function setSupervisors(data) {
  return {
    type: "SET_SUPERVISORS",
    payload: data,
  };
}

export function setAllAgents(data) {
  let modifiedData = [];
  allOngoingCallsData = [];
  return (dispatch) => {
    data
      .filter((item) => !item.is_test_agent)
      .forEach((agent) => {
        agent.availability_detail.forEach((item) => {
          if (item.motive_description && item.motive_description.length > 0) {
            agent.reason = item.motive_description;
            agent.unavailableTime = item.status_begin_timestamp;
          } else {
            if (!agent.unavailableTime) {
              agent.unavailableTime = item.status_begin_timestamp;
            }
          }
        });
        if (agent.busy) {
          let callData = agent.busy_data.all_calls[0];
          agent.from = !callData.inbound
            ? agent.extension
            : callData.phone_number;
          agent.to = !callData.inbound
            ? callData.phone_number
            : agent.extension;
          agent.type = !callData.inbound ? "outgoing" : "incoming";
          agent.service_name = callData.service_name;
          agent.call_id = callData.call_id;
          agent.startTime = callData.date_start || moment().unix();
          setBusyData(agent);
        }
        if (agent.avatar) {
          if (!agent.avatar.includes("s3-eu-west-1.amazonaws.com")) {
            // Avatar is hosted on Invoxcontact server or does not have a domain
            // Prepend the default domain and render the avatar accordingly
            const defaultDomain = "https://admin.invoxcontact.com/img/avatars";
            agent.avatar = `${defaultDomain}/${agent.avatar}`;
          }
          agent.avatar = `${agent.avatar}?time=${moment().unix()}`;
        }
        modifiedData = [...modifiedData, agent];
      });
    if (allOngoingCallsData.length > 0) {
      dispatch(setAgentsOnCallList(allOngoingCallsData));
    }
    dispatch({
      type: "SET_ALL_AGENTS",
      payload: modifiedData,
    });
  };
}

function setBusyData(agent) {
  let callData = agent.busy_data.all_calls;
  callData.forEach((data) => {
    let agentCallData = {
      callData: data,
    };
    agentCallData.callData.id = data.call_id;
    agentCallData.callData.from = !data.inbound
      ? agent.extension
      : data.phone_number;
    agentCallData.callData.to = !data.inbound
      ? data.phone_number
      : agent.extension;
    agentCallData.callData.type = !data.inbound ? "outgoing" : "incoming";
    agentCallData.callData.extension = agent.extension;
    agentCallData.callData.unique_call_id =
      agentCallData.callData.id +
      "_" +
      agentCallData.callData.from +
      "_" +
      agentCallData.callData.to;
    agentCallData.callData.didAnswer = true;
    agentCallData.callData.busy = true;
    agentCallData.callData.state = "answered";
    allOngoingCallsData = [...allOngoingCallsData, agentCallData];
  });
}

export const setAgentsOnCallList = (data) => {
  return {
    type: "UPDATE_AGENTS_ON_CALL_STATUS",
    payload: data,
  };
};

export function updateAgentsCallAvailability(data) {
  return {
    type: "UPDATE_AGENTS_CALL_AVAILABILITY",
    payload: data,
  };
}

export function agentOnCall(data) {
  return {
    type: "AGENT_ONCALL",
    payload: data,
  };
}

export function agentOnCallAnswered(data) {
  return {
    type: "AGENT_ONCALL_ANSWERED",
    payload: data,
  };
}

export function agentCallTerminated(data, resetTimer = "0") {
  return {
    type: "AGENT_CALL_TERMINATED",
    payload: {
      data: data,
      resetTimer: resetTimer,
    },
  };
}

export function changeLang(lang) {

  localStorage.setItem("lang", lang);
  return (dispatch) => {
    return dispatch({
      type: "SET_LANGUAGE",
      payload: lang,
    });
  };
}
export const get_themevalue = (value) => {
  return {
    type: "get_themevalue",
    payload: value,
  };
};

export function handleLogout() {
  return {
    type: "DO_LOGOUT",
  };
}

function handleResponse(response) {
  if (response.status == 200) {
    return response;
  } else {
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function getAgentTokenData(token, url) {
  const instance = axios.create({
    headers: { "x-api-key": "zYecF0jO7F9TWOh110tO84uiMKxoVPvw1pD4PCQo" },
  });
  return (dispatch) => {
    return instance
      .get(url, {
        params: {
          ttk: token,
          timestamp: moment().unix(),
        },
      })
      .then((data) => {
        return handleResponse(data);
      });
  };
}

export function getAgentConfig() {
  return getV2AxiosInstance().post("/bridge/en/invoxapi/Agent", {
    action: "getAgentConfiguration",
    params: { agent_id: localStorage.getItem("agent_id") },
  });
}

function getAgentInfoApi() {
  return getV2AxiosInstance().post("/bridge/en/invoxapi/Agent", {
    action: "getInfo",
    params: { agent_id: localStorage.getItem("agent_id") },
  });
}

export function getAgentInfo() {
  return (dispatch) => {
    return (
      getAgentInfoApi()
        .then(handleResponse)
        // .then(data => dispatch(setAgentInfo(data.data.info)))
        .then((data) => {
          dispatch(setAgentInfo(data.data.response.items[0]));
          return handleResponse(data);
        })
    );
  };
}

export function getAgentConfigAndInfo(properties) {
  return (dispatch) => {
    return axios.all([getAgentConfig(), getAgentInfoApi()]).then(
      axios.spread(function (config, info) {
        if (
          config.data.result &&
          config.data.response &&
          config.data.response.items &&
          config.data.response.items.length &&
          info.data.result &&
          info.data.response &&
          info.data.response.items &&
          info.data.response.items.length
        ) {
          const { initial_urls } = config.data.response.items[0];
          const configration = {
            panels_display: properties.layout.panels_display
              ? properties.layout.panels_display
              : null,
            panels_order: properties.layout.panels_order
              ? properties.layout.panels_order
              : null,
            preference: {
              themetype: properties.theme,
            },
          };

          const data = { initialUrls: initial_urls, ...configration };

          dispatch(setAgentInfo(info.data.response.items[0]));
          dispatch(setAgentConfig(data));

          return handleResponse();
        }
      })
    );
  };
}

export function setAgentInfoData(payload) {
   
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "editInfo",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          "options[name]": payload.name,
          "options[surname1]": payload.surname_1,
          "options[surname2]": payload.surname_2,
          "options[email]": payload.email,
          "options[address]": payload.address,
          "options[zip]": payload.zip,
          "options[city]": payload.city,
          "options[province]": payload.province,
          "options[phone]": payload.phone,
          "options[mobile_phone]": payload.mobile_phone,
        },
      })
      .then((data) => {
        if (data.data.status) {
          dispatch(modifyAgentInfo(payload));
        }
        return handleResponse(data);
      });
  };
}

export function setAgentConfigData(payload, hasChat, updateOrder, theme = "") {
  return (dispatch) => {
    const config = {
      panels_display: {
        telephony: payload.panels_display.telephony,
        calls_in_queue: payload.panels_display.calls_in_queue,
        incoming_calls: payload.panels_display.incoming_calls,
        outgoing_calls: payload.panels_display.outgoing_calls,
        autodialer: payload.panels_display.autodialer,
        chat: false,
        agent: payload.panels_display.agent,
        web_phone:
          payload.panels_display.web_phone !== undefined
            ? payload.panels_display.web_phone
            : false,
      },
      panels_order: {
        telephony: updateOrder
          ? payload.panels_order.indexOf("telephony") + 1
          : payload.panels_order.telephony,
        calls_in_queue: updateOrder
          ? payload.panels_order.indexOf("calls_in_queue") + 1
          : payload.panels_order.calls_in_queue,
        incoming_calls: updateOrder
          ? payload.panels_order.indexOf("incoming_calls") + 1
          : payload.panels_order.incoming_calls,
        outgoing_calls: updateOrder
          ? payload.panels_order.indexOf("outgoing_calls") + 1
          : payload.panels_order.outgoing_calls,
        autodialer: updateOrder
          ? payload.panels_order.indexOf("autodialer") + 1
          : payload.panels_order.autodialer,
        chat: hasChat
          ? updateOrder
            ? payload.panels_order.indexOf("chat") + 1
            : payload.panels_order.chat
          : payload.panels_order.length + 1,
        agent: updateOrder
          ? payload.panels_order.indexOf("agent") + 1
          : payload.panels_order.agent,
        web_phone:
          payload.panels_order.web_phone !== undefined
            ? updateOrder
              ? payload.panels_order.indexOf("web_phone") + 1
              : payload.panels_order.web_phone
            : 1,
      },
      preference: {
        themetype: theme,
      },
    };

    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "setAgentConfiguration",
        params: { agent_id: localStorage.getItem("agent_id"), config: config },
      })
      .then((data) => {
        dispatch(setAgentConfig(config));
        return handleResponse(data);
      });
  };
}

export function setAgentLanguage(lang) {
  localStorage.setItem("lang", lang);
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "editInfo",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          "options[language]": lang,
        },
      })
      .then((data) => {
        dispatch({
          type: "SET_LANGUAGE",
          payload: lang,
        });
        return handleResponse(data);
      });
  };
}

export function getRecording(call_id) {
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Call", {
        action: "getRecording",
        params: {
          call_id: call_id,
        },
      })
      .then((data) => {
        return handleResponse(data);
      });
  };
}

export function changePassword(payload) {
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "changePassword",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          password: payload.oldPass,
          new_password: payload.newPass,
        },
      })
      .then((data) => {
        return handleResponse(data);
      });
  };
}

export function listenCall(payload) {
    return (dispatch) => {

        // Con grapQL.
        return getV2AxiosInstance()
          .post("/bridge/en/invoxapi/Call", {
            "action": "whisper",
            "params":{
              "call_id":payload.call_id, 
              "extension": payload.extension, 
              "type": payload.whisper_type
            },
          })
          .catch((error) => {
              // console.log("listenCall EXCEPTION", error);              
          })
          .then((data) => {
              // Response example:
              /*
                {
                    "action_id": "302",
                    "action_status": "QUEUED"
                }
              */
              return handleResponse(data);
          });

        /*                   
        return getV2AxiosInstance()
          .post("/bridge/en/invoxapi/Call", {
              action: "listen",
              params: {
                call_id: payload.call_id,
                extension: payload.extension,
              },
          })
          .then((data) => {
              // console.log('listenCall', data);
              return handleResponse(data);
          });
        */            

    };
}

export function hangUpCall(payload) {
    return (dispatch) => {

        return getV2AxiosInstance().post("/bridge/en/invoxapi/Call", {
            action: "hangupCall",
            params: {
              options: {
                call_id: payload.call_id,
              },
            },
        }).then((data) => {
            return handleResponse(data);
        });

    };
}

export function getAgents() {
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Client", {
        action: "listAgentsByClient",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          type: 1,
          show_availability: 1,
        },
      })
      .then((data) => {
        dispatch(setAgents(data.data.response.items));
        return handleResponse(data);
      });
  };
}

export function getSupervisors() {
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Client", {
        action: "listAgentsByClient",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          type: 2,
          show_availability: 1,
        },
      })
      .then((data) => {
        dispatch(setSupervisors(data.data.response.items));
        return handleResponse(data);
      });
  };
}

export function getAllAgents() {
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "listVisibleAgents",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          show_availability: 1,
          show_internals: 0,
        },
      })
      .then((data) => {
        if (data.data.response && data.data.response.items.length > 0) {
          dispatch(setAllAgents(data.data.response.items));
          return handleResponse(data);
        }
      });
  };
}

export function uploadAvatar(img, successCallBack) {
  return (dispatch) => {
    let imgType = img.name.split(".")[1];
    let url = `https://apigw3.invoxcontact.com/9004/api/en/invoxapi/agent/${localStorage.getItem(
      "agent_id"
    )}?action=upload_avatar&type=${imgType}`;
    fetch(url, {
      headers: {
        Authorization: `${localStorage.getItem(ID_TOKEN)}`,
        "Content-Type": "application/json",
        "x-api-key": "c0rn05wuqo8F8AspQ5mtD5NaPyJ8SIcQ8gUbhovV",
      },
      method: "PATCH",
      body: img,
    })
      .then((data) => data.json())
      .then((data) => {
        if (data.result) {
          const payload = {
            avatar: `${
              data.response.items[0].avatar_url
            }?time=${moment().unix()}`,
          };
          dispatch(modifyAgentInfo(payload));
        }
        return successCallBack(data);
      })
      .catch((err) => {
        logData(err, " Catch Error");
        return false;
      });
  };
}

// export function uploadAvatar(img) {
//   return (dispatch) => {
//     return getV2AxiosInstance()
//       .post("/bridge/en/invoxapi/Agent", {
//         action: "uploadAvatar",
//         params: {
//           agent_id: localStorage.getItem("agent_id"),
//           avatar_file: img,
//         },
//       })
//       .then((data) => {
//         if (data.data.result) {
//           const payload = {
//             avatar: `${data.data.upload_result_url}?time=${moment().unix()}`,
//           };
//           dispatch(modifyAgentInfo(payload));
//         }
//         return handleResponse(data);
//       });
//   };
// }

export function doLogout() {
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/User", {
        action: "logout",
        params: {
          user_id: localStorage.getItem("agent_id"),
          is_agent: 1,
          affect_availability: 1,
        },
      })
      .then((data) => {
        return handleResponse(data);
      });
  };
}

export function testUrl(url) {
  return (dispatch) => {
    return axios
      .get("http://localhost:8888/outsource/booksalesworld/api/test_url.php", {
        params: {
          url,
          _: new Date().getTime(),
        },
      })
      .then((data) => {
        return handleResponse(data);
      });
  };
}

//NOTE - Still in use to coordinate with webphone

export function changeLanguageBackend(lang) {
  const username = localStorage.getItem("username");

  return getV2AxiosInstance()
    .patch(`/api/es/invoxapi/userproperties/${username}`, {
      data: {
        apps: {
          webagent: {
            language: lang,
          },
        },
      },
    })
    .then((data) => {
      return handleResponse(data);
    })
    .catch((err) => {
      console.log(err);
    });
}

export const setLanguageBackend = (lang) => (dispatch) => {
  localStorage.setItem("lang", lang);
  return changeLanguageBackend(lang)
    .then((data) => {
      dispatch({
        type: "SET_LANGUAGE",
        payload: lang,
      });
    })
    .catch((error) => {
      console.log("Error occurred:", error);
    });
};

//NOTE - Will be useless in 2 months

const default_settings = {
  language: "es",
  theme: "default",
  layout: {
    panels_display: {
      telephony: true,
      calls_in_queue: true,
      incoming_calls: true,
      outgoing_calls: true,
      autodialer: true,
      chat: false,
      agent: true,
      web_phone: false,
    },
    panels_order: {
      telephony: 2,
      calls_in_queue: 3,
      incoming_calls: 4,
      outgoing_calls: 5,
      autodialer: 8,
      chat: 6,
      agent: 7,
      web_phone: 1,
    },
  },
};

export function getInitialAgentConfigAndInfo() {
  return axios.all([getAgentConfig(), getAgentInfoApi()]).then(
    axios.spread(function (config, info) {
      if (
        config.data.result &&
        config.data.response &&
        config.data.response.items &&
        info.data.result &&
        info.data.response &&
        info.data.response.items
      ) {
        const language = info.data.response.items[0].language;
        const panels_display = config.data.response.items[0]
          .web_agent_configuration.panels_display
          
        const panels_order = config.data.response.items[0]
          .web_agent_configuration.panels_order
         

        const preference =
          config.data.response.items[0].web_agent_configuration.preference;
        const themetype =
          preference && preference.themetype ? preference.themetype : "default";
         
          // const themetype = "default"
        const configuration = {
          panels_display: panels_display ? panels_display : default_settings.layout.panels_display,
          panels_order: panels_order ? panels_order : default_settings.layout.panels_order,
          preference: {
            themetype: themetype,
          },
        };
        
        const data = { configuration, language };
        

        return { config: data };
      } else {
        return console.log("outside");
      }
    })
  );
}



// WEBPACK FOOTER //
// ./src/actions/getAgentConfig.js